import { Dispatch } from 'redux'

import * as UserApi from 'redux/api/DataPlatform/users/v1'
import * as CustomerApi from 'redux/api/Customers'

import { TPatchEconomy } from 'types/GlobalCustomer'
import { PatchSelfBody } from 'types/GlobalAccount'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

export function tryUpdateSelf(body: PatchSelfBody, showDialog = true) {
  return (dispatch: Dispatch) => {
    dispatch(actions.updateSelf())

    UserApi.updateSelf(body)
      .then((response) => {
        dispatch(actions.updateSelfSuccess(response.data.data))

        if (showDialog) {
          dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
        }
      })
      .catch(() => {
        dispatch(actions.updateSelfFailed())

        if (showDialog) {
          dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
        }
      })
  }
}

export function tryUpdateEconomy(body: TPatchEconomy) {
  return (dispatch: Dispatch) => {
    dispatch(actions.updateEconomy())

    CustomerApi.updateEconomy(body)
      .then((response) => {
        dispatch(actions.updateEconomySuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
      })
      .catch(() => {
        dispatch(actions.updateEconomyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export const useSelfActions = () => {
  return {
    tryUpdateSelf: useThunkActions(tryUpdateSelf),
    tryUpdateEconomy: useThunkActions(tryUpdateEconomy)
  }
}
